import { useEffect } from "react";

export const RedirectToExternal = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};
